import React from 'react';
import CourseForm from '@components/courseForm/CourseForm';
import withCourse from '@hoc/withCourse';
import { useGetCourseLessonsQuery, useGetCurrentUserQuery } from '@teachur/http-client';

interface EditCourseProps {
  course: Course;
}

const EditCourse: React.FC<EditCourseProps> = ({ course }) => {
  const { data: user } = useGetCurrentUserQuery();
  const { data, isLoading } = useGetCourseLessonsQuery(course.id);

  if (!user || isLoading || !data) {
    return null;
  }

  return <CourseForm course={course} lessons={data as any} />;
};

const ConnectedEditCourse = withCourse(EditCourse);

const Page = () => <ConnectedEditCourse />;

export default Page;
